import React from 'react';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import '@okta/okta-signin-widget/dist/css/okta-theme.css';
import {connect} from "react-redux";

import {Grid, Typography} from "material-ui";
import ItemGrid from "../components/Grid/ItemGrid";
import {oktaSignIn} from "../index";

export class LoginPage extends React.Component {
    constructor() {
        super();
        this.state = {user: null};
        this.showLogin = this.showLogin.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentDidMount() {
        oktaSignIn.session.get((response) => {
            this.setState({user: null});
            this.showLogin();
        });
    }

    showLogin() {
        oktaSignIn.renderEl({
            el: '#okta-login-container'
        }, function success(res) {
            if (res.status === 'SUCCESS') {
                console.log('Succeeded getting token' + res.session.token);
            } else {
                console.log('Error occurred in getting token.');
            }
        });

    }

    logout() {
        oktaSignIn.signOut(() => {
            this.setState({user: null});
            this.setState({auth: null});
            this.showLogin();
        });
    }

    render() {
        return (
            <div>
                <Grid container>
                    <ItemGrid xs={12} sm={12} md={12} style={{backgroundColor: '#20313b', textAlign: 'center'}}>
                        <Typography variant="display1" style={{color: '#fff'}}>
                            NTS Order Monitoring App
                        </Typography>
                    </ItemGrid>
                    <ItemGrid xs={12} sm={12} md={12} style={{backgroundColor: '#20313b', textAlign: 'center'}}>
                        <Typography variant="headline" style={{color: '#fff'}}>
                            Live tracking orders and reports
                        </Typography>
                    </ItemGrid>
                    <ItemGrid xs={12} sm={12} md={12} style={{backgroundColor: '#ddd'}}>
                        {this.state.user ? null : (
                            <div id="okta-login-container" className="login"/>
                        )}
                    </ItemGrid>
                </Grid>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        auth: state.authState.auth
    }
};

const Login = connect(
    mapStateToProps
)(LoginPage);

export default Login;


// WEBPACK FOOTER //
// ./src/layouts/LoginPage.js